// React-router v7 future flags: transition-aware navigation and relative splat
// path resolution. Kept standalone so every Indie router uses one policy.
export const routerFuture = {
  v7_startTransition: true,
  v7_relativeSplatPath: true,
} as const;
